<template>
  <footer color="stylish-color-dark" class="page-footer font-small pt-4 mt-4">
    <b-container class="text-left">
      <b-row>
        <b-col md="6">
          <h5 class="text-uppercase mb-4 mt-3 font-weight-bold">Support</h5>
          <ul class="list-unstyled">
            <li class="mb-4">An questions or problems with an exhibit?<br>
              Contact our support via <b-link :href="supportMail">Email</b-link> and you will directly be integrated<br>
              in our Ticket-System.</li>
            <li><b-link :href="supportMail"><b-img height="40" src="https://www.archimedes-exhibitions.de/site/uploads/2018/11/amdx-logo.svg"/></b-link></li>
          </ul>
        </b-col>
        <hr class="clearfix w-100 d-md-none" />
        <b-col md="3">
          <h5 class="text-uppercase mb-4 mt-3 font-weight-bold">EMS</h5>
          <ul class="list-unstyled">
            <li><b-link to="/">Map</b-link></li>
            <li><b-link to="/power">Power</b-link></li>
            <li><b-link to="/content">Content</b-link></li>
            <li><b-link to="/timeline">Timeline</b-link></li>
            <li><b-link to="/control">DirectControl</b-link></li>
            <li><b-link to="/docs">Documentation</b-link></li>
            <li><b-link to="/clients">Clients</b-link></li>
            <li><b-link to="/drivers">Drivers</b-link></li>
          </ul>
        </b-col>
        <hr class="clearfix w-100 d-md-none" />
        <b-col md="3">
          <h5 class="text-uppercase mb-4 mt-3 font-weight-bold">Docs</h5>
          <ul class="list-unstyled">
            <li><b-link :to="{ name: 'docsDetails', params: { section: 'bptc-exhibit-layout' }}">Layouts</b-link></li>
            <li><b-link :to="{ name: 'docsDetails', params: { section: 'power-management' }}">Power</b-link></li>
            <li><b-link :to="{ name: 'docsDetails', params: { section: 'cms' }}">Content</b-link></li>
            <li><b-link :to="{ name: 'docsDetails', params: { section: 'scheduling' }}">Timeline</b-link></li>
            <li><b-link :to="{ name: 'docsDetails', params: { section: 'direct-control' }}">DirectControl</b-link></li>
            <li><b-link :to="{ name: 'docsDetails', params: { section: 'service-support' }}">Service & Support</b-link></li>
          </ul>
        </b-col>
        <hr class="clearfix w-100 d-md-none" />
      </b-row>
    </b-container>
    <div class="text-center">
      <ul class="list-unstyled list-inline">
        <li class="list-inline-item"><a class="btn-floating btn-sm btn-fb mx-1"><i class="fab fa-facebook"> </i></a></li>
        <li class="list-inline-item"><a class="btn-floating btn-sm btn-tw mx-1"><i class="fab fa-twitter"> </i></a></li>
        <li class="list-inline-item"><a class="btn-floating btn-sm btn-gplus mx-1"><i class="fab fa-google-plus"> </i></a></li>
        <li class="list-inline-item"><a class="btn-floating btn-sm btn-li mx-1"><i class="fab fa-linkedin-in"> </i></a></li>
        <li class="list-inline-item"><a class="btn-floating btn-sm btn-dribbble mx-1"><i class="fab fa-dribbble"> </i></a></li>
      </ul>
    </div>
    <div class="footer-copyright text-center py-3">
      <b-container fluid>
        &copy; 2020 Copyright: <b-link href="https://www.archimedes-exhibitions.de"> Archimedes-Exhibitions GmbH </b-link>
      </b-container>
    </div>
  </footer>
</template>

<script>
  import Vue from 'vue'

  export default {
    name: 'Footer',
    data () {
      return {
      }
    },
    computed: {
      supportMail () {
        return 'mailto:' + Vue.prototype.$SUPPORT_EMAIL
      }
    }
  }
</script>
<style lang="scss" scoped>
  footer {
    background-color: #f2f2f2;
    border-top: 3px solid #dee2e6;
    text-align: center;
  }

</style>
